export const LEVEL = {
  EASY: 'easy',
  MEDIUM: 'medium',
  HARD: 'hard',
};

export const LEVEL_OPTIONS = [
  {
    slug: LEVEL.EASY,
    label: 'Fácil',
    color: 'text-success',
  },
  {
    slug: LEVEL.MEDIUM,
    label: 'Médio',
    color: 'text-warning',
  },
  {
    slug: LEVEL.HARD,
    label: 'Difícil',
    color: 'text-danger',
  },
];

export const LEVELS = Object.values(LEVEL);

const LEVEL_BY_SLUG = Object.fromEntries(
  LEVEL_OPTIONS.map(level => [level.slug, level]),
);

export const getLevelOption = slug => LEVEL_BY_SLUG[slug];

export const getLevelLabel = slug => {
  const label = LEVEL_BY_SLUG[slug]?.label;
  return label || '';
};

export const getLevelColor = slug => {
  const color = LEVEL_BY_SLUG[slug]?.color;
  return color || '';
};
